import React from 'react';
import { IconButton, Tooltip, useTheme, alpha } from '@mui/material';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';

const HOVER_UI_MS = 200;

type Props = {
  /** כשהשורה «שיחות» בריחוף — מציג את כפתור התיקייה */
  headerHovered: boolean;
  /** יצירת תיקייה חדשה (אחסון מקומי בלבד — TODO(DB)) */
  onCreateFolderClick: () => void;
};

/** כפתור «תיקייה חדשה» בכותרת «שיחות» — בריחוף בלבד. הוספת תצוגה — ב-+ ליד שם תיקייה מותאמת. */
function ChatViewsAllViewsMenu({ headerHovered, onCreateFolderClick }: Props) {
  const theme = useTheme();

  return (
    <Tooltip title="תיקייה חדשה">
      <span>
        <IconButton
          size="small"
          disableRipple
          aria-label="תיקייה חדשה"
          tabIndex={headerHovered ? 0 : -1}
          aria-hidden={!headerHovered}
          onClick={onCreateFolderClick}
          sx={{
            width: 28,
            height: 28,
            minWidth: 28,
            borderRadius: 1,
            color: 'text.secondary',
            opacity: headerHovered ? 1 : 0,
            pointerEvents: headerHovered ? 'auto' : 'none',
            transition: (t) =>
              t.transitions.create(['opacity', 'background-color', 'color'], { duration: HOVER_UI_MS }),
            '&:hover': {
              bgcolor: alpha(theme.palette.grey[500], 0.1),
              color: 'text.primary',
            },
          }}
        >
          <CreateNewFolderOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </span>
    </Tooltip>
  );
}

export default React.memo(ChatViewsAllViewsMenu);
